import React from 'react';
import config from '../../../../config/config';
import words from '../../../../utils/words';
import { isSell } from '../../../../utils/transactions-util';

const AddressUndeliverableFundNoteTip = () => (
  <div className="exclude">
    Mail sent to the address on file for this{' '}
    {isSell() ? 'account' : words.fund} was marked as undeliverable.
    {isSell() ? ' If you' : ' To transact,'}{' '}
    {isSell() ? (
      'update your address'
    ) : (
      <a
        className="text-nowrap exclude college-branded-link"
        href={`${config.url}/usis/my-accounts/profile/contact-information`}
      >
        update your address
      </a>
    )}
    {isSell()
      ? ', proceeds from a redemption submitted online can only be sent to a linked bank account and cannot be sent by check for 15 days following the change. If your address is correct or to discuss the options available to you for placing this redemption, please '
      : ' which then can take up to 24 hours to process. Please '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${config.url}/personal-investing/help/contact/index.html`}
      className="exclude"
    >
      contact us
    </a>
    {!isSell() &&
      ' to discuss the options available to you for placing this transactions'}
    .
  </div>
);

export default AddressUndeliverableFundNoteTip;
